import SystemTransfer from '@/features/points-management/system-transfer';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'transactionId',
    'transactionDate',
    'transactionType',
    'userType',
    'user',
    'points',
    'remarks',
    'createdDate',
  ]),
  desc: z.boolean(),
});

const systemTransferSearchSchema = z.object({
  sort: z.preprocess((val) => {
    if (typeof val === 'string') {
      try {
        return JSON.parse(val);
      } catch {
        return undefined;
      }
    }
    return val;
  }, z.array(sortItemSchema).optional()),
});

export const Route = createFileRoute('/(app)/points-management/system-transfer/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => systemTransferSearchSchema.parse(search),
});

function RouteComponent() {
  return <SystemTransfer />;
}
